import './App.css';

function App() {
  return (
      <div className="min-h-screen bg-gray-50 text-gray-800 flex flex-col items-center px-6 py-10">
    {/* Header */}
    <header className="w-full max-w-4xl text-center mb-12">
    <h1 className="text-4xl font-bold mb-4">Sajida Parveen</h1>
    <p className="text-lg text-gray-600">Innovative App Developer</p>
    </header>


    {/* Intro Section */}
    <section className="w-full max-w-3xl bg-white shadow-lg rounded-2xl p-8 mb-10">
    <h2 className="text-2xl font-semibold mb-4">About Us</h2>
    <p className="text-gray-700 leading-relaxed">
    Welcome to the official developer page of <strong>Sajida Parveen</strong>. We create
    modern, intuitive, and innovative mobile applications designed to make everyday life
    easier and more productive. Our goal is to build digital solutions that bring simplicity,
    creativity, and value to users around the world.
    </p>
    </section>


    {/* Apps Section */}
    <section className="w-full max-w-3xl bg-white shadow-lg rounded-2xl p-8 mb-10">
    <h2 className="text-2xl font-semibold mb-4">Our Apps</h2>
    <p className="text-gray-700 mb-4">We are actively developing and publishing innovative apps on the App Store. Stay tuned for upcoming releases!</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
   
    </div>
    </section>


    {/* Contact Section */}
    <section className="w-full max-w-3xl bg-white shadow-lg rounded-2xl p-8 mb-10">
    <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
    <p className="text-gray-700 leading-relaxed">
    For feedback, inquiries, or support, feel free to reach out to us:
    </p>
    <p className="mt-3 font-medium">Email: <a href="mailto:feedback.sajida@gmail.com" className="text-blue-600 underline">feedback.sajida@gmail.com</a></p>
    </section>


    {/* Footer */}
    <footer className="mt-10 text-gray-500 text-sm">
    © {new Date().getFullYear()} Sajida Parveen — All Rights Reserved.
    </footer>
    </div>
  );
}

export default App;
